import { render, staticRenderFns } from "./ConfirmReceiptDialog.vue?vue&type=template&id=b996f70a"
import script from "./ConfirmReceiptDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmReceiptDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmReceiptDialog.vue?vue&type=style&index=0&id=b996f70a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports